import { API } from '../Auth';

// Admin service-registry CRUD — backs the Services panel. Talks to the platform-api
// (/api/admin/services), which is ADMIN-gated server-side. File-defined core services are
// returned with source === 'FILE' and are read-only; DB-backed rows have source === 'DB'.
const BACKEND = 'api';
const BASE = '/api/admin/services';

const listServices = async () => {
  const res = await API.get(BACKEND, BASE);
  return Array.isArray(res) ? res : [];
};

// Adapter types the integrations container offers (GET /api/admin/services/adapters), used to
// populate the "add instance" picker. Each: { vendorId, displayName, pathPrefix, roles, ... }.
const listAdapters = async () => {
  try {
    const res = await API.get(BACKEND, `${BASE}/adapters`);
    return Array.isArray(res) ? res : [];
  } catch {
    return [];
  }
};

const createService = async (service) => {
  try {
    return await API.post(BACKEND, BASE, { body: service });
  } catch (error) {
    throw new Error(error?.response?.data?.message || error.message);
  }
};

const updateService = async (id, service) => {
  try {
    return await API.put(BACKEND, `${BASE}/${encodeURIComponent(id)}`, { body: service });
  } catch (error) {
    throw new Error(error?.response?.data?.message || error.message);
  }
};

const deleteService = async (id) => {
  try {
    return await API.del(BACKEND, `${BASE}/${encodeURIComponent(id)}`);
  } catch (error) {
    throw new Error(error?.response?.data?.message || error.message);
  }
};

const testService = async (id) => {
  try {
    return await API.post(BACKEND, `${BASE}/${encodeURIComponent(id)}/test`, {});
  } catch (error) {
    throw new Error(error?.response?.data?.message || error.message);
  }
};

export { listServices, listAdapters, createService, updateService, deleteService, testService };
